<template>

    <div class="user">
    
  
      
        <div style="width: 100%;border: 1px solid #f7f7f7;float: left;height: 550px;overflow-y: auto;padding: 10px; ">
          <el-form :inline="true" size="small"  class="demo-form-inline">
         
            <el-form-item >
              <el-input style="width: 45%;float: left;" placeholder="请输入货运公司名称" v-model="supply_search">
            
             </el-input>
              <el-button  style="width: 25%;float: left;margin-left: 2%;" type="primary" icon="el-icon" @click="getSupply">查询</el-button>
              <el-button  style="width: 25%;float: left;margin-left: 2%;background: #999;border: 1px solid #999;" type="primary" icon="el-icon" @click="reast">重置</el-button>
              <div style="clear: both;"></div>
            </el-form-item>
  
        </el-form>  
          
          
        <el-table
              ref="singleTable"
              :data="supplyList"
              highlight-current-row
              @current-change="handleCurrentChange"
              border
              style="width: 100%">
              <el-table-column
                property="user_id"
                label="ID"
                width="80">
              </el-table-column>
              <el-table-column
                property="nickName"
                label="名称">
              </el-table-column>

                <el-table-column prop="mobile" label="手机号码" width="120">
              <template slot-scope="scope">

                <p style="color: #447fff;" @click="copy( scope.row.mobile)">{{ scope.row.mobile }}</p>
              </template>
            </el-table-column>

            <el-table-column prop="mobile" label="邮箱" width="120">
              <template slot-scope="scope">

                <p style="color: #447fff;" @click="copy( scope.row.email)">{{ scope.row.email }}</p>
              </template>
            </el-table-column>
              
            </el-table>
    </div>
      
    

    
    </div>
  </template>
  
  <script>

    import SupplyApi from '@/api/supply.js';
    import HyApi from '@/api/hy.js';
  
    export default {

      inject: ['reload'],
      data() {
        return {
        
  
  
          supply_search:"",
          supplyList:[],
          currentRow :null
        };
      },
      created() {
        this.getSupply();
 
      },
      methods: {
        copy(value){
        var copyContent = document.createElement('input');     //创建一个隐藏input（重要！）
                copyContent.value = value
                document.body.appendChild(copyContent);
                copyContent.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("复制成功！");
                copyContent.remove();
        },
        handleCurrentChange(val) {
    
            this.currentRow = val;

          let self = this;
          self
            .$confirm('是否分配给该货运公司?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
         
            })
            .catch(() => {
            });
            //this.$emit("handleCurrentChange", { openDialog: false,"id":val.supply_id });
      },
      reast() {
    
                this.currentRow = null;
                this.$emit("reast", { openDialog: false,"id":0 });
            },
        getSupply() {
            let self = this;
            self.loading = true
            let Params = {}
            Params.page = 1
            Params.list_rows = 9000
            Params.search = self.supply_search
            HyApi.userlist(Params, true)
              .then(data => {
                self.loading = false
                self.supplyList = data.data.list.data
   
              })
              .catch(error => {
                self.loading = false
              });
      },
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/select/hy.vue